/** Client-side tier catalog (mirrors backend/tiers.py) for pricing UI fallback. */
const annual = (monthly) => Math.round(monthly * 10 * 100) / 100;

export const FALLBACK_TIER_CATALOG = {
  tiers: [
    {
      slug: 'free',
      display_name: 'Free',
      price_monthly_usd: 0,
      price_annual_usd: 0,
      max_properties: 2,
      ai_enabled: false,
      max_monthly_notifications: 10,
      bulk_import_enabled: false,
      priority_support: false,
      api_access: false,
      is_paid: false,
      recommended: false,
      features: ['2 properties', '10 emails/month', 'Core property management'],
    },
    {
      slug: 'starter',
      display_name: 'Starter',
      price_monthly_usd: 5,
      price_annual_usd: annual(5),
      max_properties: 2,
      ai_enabled: true,
      max_monthly_notifications: null,
      bulk_import_enabled: false,
      priority_support: false,
      api_access: false,
      is_paid: true,
      recommended: false,
      features: ['2 properties', 'AI insights', 'Unlimited email notifications'],
    },
    {
      slug: 'starter_plus',
      display_name: 'Starter Plus',
      price_monthly_usd: 10,
      price_annual_usd: annual(10),
      max_properties: 25,
      ai_enabled: true,
      max_monthly_notifications: null,
      bulk_import_enabled: false,
      priority_support: false,
      api_access: false,
      is_paid: true,
      recommended: false,
      features: ['25 properties', 'AI insights', 'Unlimited email notifications'],
    },
    {
      slug: 'pro',
      display_name: 'Pro',
      price_monthly_usd: 25,
      price_annual_usd: annual(25),
      max_properties: 50,
      ai_enabled: true,
      max_monthly_notifications: null,
      bulk_import_enabled: false,
      priority_support: false,
      api_access: false,
      is_paid: true,
      recommended: false,
      features: ['50 properties', 'AI insights', 'Unlimited email notifications'],
    },
    {
      slug: 'pro_plus',
      display_name: 'Pro Plus',
      price_monthly_usd: 50,
      price_annual_usd: annual(50),
      max_properties: null,
      ai_enabled: true,
      max_monthly_notifications: null,
      bulk_import_enabled: false,
      priority_support: false,
      api_access: false,
      is_paid: true,
      recommended: true,
      features: ['Unlimited properties', 'AI insights', 'Unlimited email notifications'],
    },
    {
      slug: 'business',
      display_name: 'Business',
      price_monthly_usd: 100,
      price_annual_usd: annual(100),
      max_properties: null,
      ai_enabled: true,
      max_monthly_notifications: null,
      bulk_import_enabled: true,
      priority_support: true,
      api_access: false,
      is_paid: true,
      recommended: false,
      features: [
        'Unlimited properties',
        'Bulk property import',
        'Priority support',
        'AI insights',
        'Unlimited email notifications',
      ],
    },
    {
      slug: 'enterprise',
      display_name: 'Enterprise',
      price_monthly_usd: null,
      price_annual_usd: null,
      max_properties: null,
      ai_enabled: true,
      max_monthly_notifications: null,
      bulk_import_enabled: true,
      priority_support: true,
      api_access: true,
      is_paid: true,
      recommended: false,
      features: [
        'Everything in Business',
        'Accountant software API access',
        'Custom pricing',
      ],
    },
  ],
  recommended_tier: 'pro_plus',
  trial_days: 14,
};
